import React, { FC } from 'react';
import { H2, ModalContent, ModalHeader, ModalTitle, Text } from 'components';
import { IPOSProvider, ISiteIntegration } from 'types';
import { formatIntegrationName } from 'utils';
import { ActionText, ContentFooter, FooterAction, Layout, StyledSubtitle, Wrapper } from '../styles';
import EmployeeInfo from './EmployeeInfo';

interface INoMatchProps {
  dataCy: string;
  integration: ISiteIntegration;
  provider: IPOSProvider;
  onClose(): void;
  onSearch(): void;
}

const NoMatch: FC<INoMatchProps> = ({ provider, integration, onSearch, onClose, dataCy }: INoMatchProps) => (
  <Layout isActive onClose={onClose} data-cy={`${dataCy}-no-match`} maxWidth={540}>
    <ModalHeader>
      <ModalTitle data-cy="modal-title">Connect {formatIntegrationName(integration)} Employee To Kickfin</ModalTitle>
      <StyledSubtitle data-cy="modal-subtitle">Create a connection between employees on your POS to Kickfin users.</StyledSubtitle>
    </ModalHeader>
    <ModalContent>
      <Wrapper>
        <EmployeeInfo name={provider.name} type={provider.type} employeeId={provider.customerEmployeeId} dataCy={dataCy} />
        <Wrapper center>
          <H2 fontWeight="semibold">Sorry, we're unable to find a Kickfin match</H2>
          <ContentFooter>
            <FooterAction>
              <ActionText size="small" fontWeight="semibold" onClick={onSearch}>
                Click here
              </ActionText>
              <Text size="small">to search your entire list of users.</Text>
            </FooterAction>
          </ContentFooter>
        </Wrapper>
      </Wrapper>
    </ModalContent>
  </Layout>
);

export default NoMatch;
